import Vue from 'vue';

export default {
  state: {
    dimentions: [],
  },
  getters: {
    dimentions(state) {
      return state.dimentions;
    },
  },
  mutations: {
    SET_DIMENTIONS(state, payload) {
      state.dimentions = payload;
    },
  },
  actions: {
    GET_DIMENTIONS(context) {
      return Vue.axios.get('filters/dims').then((response) => {
        context.commit('SET_DIMENTIONS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/dimentions.js